import React from 'react';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
}

const renderTableBody = (headers, data, checkbox, openDocumentDetails) => {
    let body: "";

    body = data.map((register, index) => {
        let docDate = new Date(register.docDate);
        let CreateTime =  ((register.docTime).trim() || '').toString();

        if(CreateTime.length > 0){
            let position = CreateTime.length - 2;
            CreateTime = CreateTime.slice(0, position) + ":" + CreateTime.slice(position, CreateTime.length)
         }
        docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
       
        return (
            <tr key={index}>

                {headers[0].value && <td>{moment(docDate).format("DD-MM-YYYY")}</td>}
                {headers[1].value && <td className="text-right font-weight-bold">{register.cardCode}</td>}
                {headers[2].value && <td>{register.CardName}</td>}
                {headers[3].value && <td>{register.reason}</td>}
                {headers[4].value && <td className="text-center">{register.nameDocument}</td>}
                {headers[5].value && <td className="text-center" style={{color: (register.status).trim() === 'Y' ? 'green' : 'black'}}>{(register.status).trim() === 'Y' ? "Procesado" : "Sin procesar"}</td>}
                {headers[6].value && <td>{CreateTime}</td>}
                
                <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                    {register.docEntry && <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDocumentDetails({DocEntry: register.docEntry, index, DocType: register.docType})}
                            style={{fontWeight: '500'}}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>}
                </td>
            </tr>
        )
        
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}

            <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{width: '100%'}}>
        <thead className="table-header">
        {header}
        </thead>
        <tbody>
        {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableMiddleware = (headers, data, checkbox, openDocumentDetails) => {

    return renderTable(headers, data, checkbox, openDocumentDetails);

}
